import Repository from "@/plugins/axios";

export default {
  // Получить информацию по QR-хэшу
  getQr(hash) {
    return Repository.get(`/qr/${hash}`);
  },
};
